import { render, staticRenderFns } from "./WardrobeClean.vue?vue&type=template&id=3bac9c0a&scoped=true"
import script from "./WardrobeClean.vue?vue&type=script&lang=js"
export * from "./WardrobeClean.vue?vue&type=script&lang=js"
import style0 from "./WardrobeClean.vue?vue&type=style&index=0&id=3bac9c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac9c0a",
  null
  
)

export default component.exports